import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getElementosProteccionPersonal } from "../../../../../../redux/actions/resolucion";
import ElementosDeProteccionFormContainer from "./ElementosDeProteccionFormContainer";
import ElementosDeProteccionTable from "./ElementosDeProteccionTable";


const ElementosDeProteccionTabContainer = ({ }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext()

  const [openForm, setOpenForm] = useState();


  useEffect(() => {
    dispatch(getElementosProteccionPersonal())
  }, [openForm])

  const handleDelete = (idToDelete) => {
    setFieldValue("elementosDeProteccion", values.elementosDeProteccion.filter((e) => e.idElementoDeProteccion !== idToDelete))
  }

  const handleAdd = (elementoDeProteccion) => {
    setFieldValue("elementosDeProteccion", [...values.elementosDeProteccion, elementoDeProteccion]);
    setOpenForm(false);
  }

  return (
    <>

      <ElementosDeProteccionTable
        handleDelete={handleDelete}
        handleOpenAddForm={() => setOpenForm(true)}
        data={values.elementosDeProteccion}
      />
      <ElementosDeProteccionFormContainer
        open={openForm}
        handleClose={() => setOpenForm(false)}
        handleSubmit={handleAdd}
        selectedOptions={values.elementosDeProteccion}
      />
    </>
  )
}

export default ElementosDeProteccionTabContainer;